import { useTranslation } from 'react-i18next';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { LangSwitcher } from '@/components/LangSwitcher.jsx';
import { useSessionStore } from '@/lib/session.js';

const NAV = {
  DOCTOR: [
    { to: '/doctor', key: 'nav.dashboard' },
    { to: '/doctor/new', key: 'nav.newPrescription' },
    { to: '/doctor/list', key: 'nav.myPrescriptions' },
  ],
  PHARMACY: [
    { to: '/pharmacy', key: 'nav.scan' },
    { to: '/pharmacy/history', key: 'nav.history' },
  ],
  ADMIN: [{ to: '/admin/doctors', key: 'nav.pendingDoctors' }],
};

export function AppLayout() {
  const { t } = useTranslation();
  const { user, logout } = useSessionStore();
  const navigate = useNavigate();
  const items = NAV[user?.role] ?? [];

  async function onLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="flex flex-wrap items-center justify-between gap-3 border-b bg-white px-4 py-3 shadow-sm">
        <div className="flex items-center gap-3">
          <h1 className="text-lg font-semibold text-slate-900">E-Rx</h1>
          <span className="rounded bg-slate-100 px-2 py-0.5 text-xs uppercase text-slate-600">
            {user?.role}
          </span>
        </div>
        <nav className="flex flex-wrap gap-2">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end
              className={({ isActive }) =>
                `rounded px-3 py-1.5 text-sm ${
                  isActive ? 'bg-brand-600 text-white' : 'text-slate-700 hover:bg-slate-100'
                }`
              }
            >
              {t(it.key, { defaultValue: it.key })}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="text-xs text-slate-500">{user?.email}</span>
          <LangSwitcher />
          <button
            type="button"
            onClick={onLogout}
            className="rounded border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100"
          >
            {t('nav.logout', { defaultValue: 'Logout' })}
          </button>
        </div>
      </header>
      <main className="flex-1 p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  );
}
